export function validateCoordinates(lat: number, lng: number): void {
  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    isNaN(lat) ||
    isNaN(lng)
  ) {
    throw new Error('Latitude and longitude must be valid numbers.');
  }

  if (lat < -90 || lat > 90) {
    throw new Error('Latitude must be between -90 and 90 degrees.');
  }

  if (lng < -180 || lng > 180) {
    throw new Error('Longitude must be between -180 and 180 degrees.');
  }
}

/**
 * Brings a longitude back into [-180, 180).
 *
 * Mapbox renders copies of the world side by side, and a pointer event's `lngLat` is not wrapped:
 * hovering the copy to the east of the antimeridian reports e.g. 190 for what is really -170. Zoomed
 * out (or panned a whole world sideways) that is the ordinary case, not an edge one.
 */
export function wrapLongitude(lng: number): number {
  return ((((lng + 180) % 360) + 360) % 360) - 180;
}
